<template>
    <div>
        <div class="from-div">
            <el-form   label-position="rigth" ref="from" :model="from" label-width="120PX">
                <el-form-item label="申诉账号:" prop="user" >
                    <el-input v-model.trim="from.user"   placeholder="申诉单中填写的账号" style="width:250PX;"></el-input>
                </el-form-item>
                <el-form-item label="申诉回执编码:" prop="code">
                    <el-input v-model.trim="from.code" placeholder="联系邮箱里填写的17位回执编码" style="width:250PX;"></el-input> 
                </el-form-item>
            </el-form>
        </div>
        <div class="btn-div">
            <el-button class="bak" style="margin-left: -80PX;" type="primary" @click="goHome">返回</el-button>
            <el-button class="btn" type="primary" @click="next('from')">下一步</el-button>
        </div>
    </div>
</template>

<script>
export default {
     data() {
        return {
            from:{
                user:"",
                code:""
            }
         };
     },
//部件
 components: {
 },
//属性的结果会被缓存，除非依赖的响应式属性变化才会重新计算。主要当作属性来使用；
 computed: { 
 },
//方法表示一个具体的操作，主要书写业务逻辑；
 methods: { 
     goHome(){
            this.resetSetItem('isHelpView', 0);
        },
        next(from){

        }
 },
//请求数据
 created() {
},
 mounted() {
}
}
</script>

<style scoped>
.from-div{
    margin: 30PX auto!important;
    width: 500PX;
}
.btn-div{

    margin-top: 50PX;
    text-align: center;
}
.btn{
    color:rgba(255,255,255,1);
    width:190PX;
    height:50PX;
    background:rgba(62,141,221,1);
    border-radius:4PX;
}
.bak{
    color:rgba(51,51,51,1);
    width:190PX;
    height:50PX;
    background:rgba(215,215,215,1);
    border:1PX solid rgba(184, 184, 184, 1);
    border-radius:4PX;
}
</style>



// WEBPACK FOOTER //
// src/components/cards/query.vue